import { useMemo } from "react";
import { useTypography } from "../../../hooks/useTypography.js";
import { parseNumericPixelValue } from "../utils/fontSize.js";
function useTypographyVariant(section) {
  const {
    onTypographyChange,
    onTypographyReset,
    onTypographyResetAll,
    typography,
    previewTypography: prevTypography
  } = useTypography();
  return useMemo(() => {
    const previewTypography = prevTypography ?? {};
    const htmlFontSize = typography.htmlFontSize;
    return {
      all: {
        disabled: !previewTypography[section],
        onReset: () => onTypographyResetAll(section)
      },
      fontSize: {
        disabled: !("fontSize" in (previewTypography?.[section] ?? {})),
        onChange: (value) => {
          onTypographyChange(section, "fontSize", value);
        },
        onReset: () => onTypographyReset(section, "fontSize"),
        pxValue: parseNumericPixelValue(typography[section].fontSize ?? "1rem", htmlFontSize),
        value: typography[section].fontSize ?? "1rem"
      },
      fontWeight: {
        disabled: !("fontWeight" in (previewTypography?.[section] ?? {})),
        onChange: (value) => {
          onTypographyChange(section, "fontWeight", value);
        },
        onReset: () => onTypographyReset(section, "fontWeight"),
        value: typography[section].fontWeight ?? 400
      },
      htmlFontSize,
      letterSpacing: {
        disabled: !("letterSpacing" in (previewTypography?.[section] ?? {})),
        onChange: (value) => {
          onTypographyChange(section, "letterSpacing", value);
        },
        onReset: () => onTypographyReset(section, "letterSpacing"),
        value: typography[section].letterSpacing ?? 0
      },
      lineHeight: {
        disabled: !("lineHeight" in (previewTypography?.[section] ?? {})),
        onChange: (value) => {
          onTypographyChange(section, "lineHeight", value);
        },
        onReset: () => onTypographyReset(section, "lineHeight"),
        value: typography[section].lineHeight ?? 1
      }
    };
  }, [onTypographyChange, onTypographyReset, section, typography, onTypographyResetAll, prevTypography]);
}
export {
  useTypographyVariant
};
//# sourceMappingURL=useTypographyVariant.js.map
